module.exports = __webpack_public_path__ + "static/img/03013A_4_R_20200704_LC.c21f08e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/03013A_4_R_20200704_LC.png
// module id = uI2o
// module chunks = 0